import { create } from "zustand";
import type { TimeEntry } from "@/types/time";

interface TimeStore {
  // Entry dialog
  entryDialogOpen: boolean;
  editEntry: TimeEntry | null;
  openCreateDialog: () => void;
  openEditDialog: (entry: TimeEntry) => void;
  closeEntryDialog: () => void;

  // Week navigation (shared between My Time and Everyone)
  weekOffset: number;
  setWeekOffset: (offset: number | ((prev: number) => number)) => void;

  // Everyone view
  selectedMemberId: string | null;
  selectedMemberName: string;
  selectedMemberEmail: string;
  openMemberDialog: (id: string, name: string, email: string) => void;
  closeMemberDialog: () => void;
}

export const useTimeStore = create<TimeStore>((set) => ({
  // Entry dialog
  entryDialogOpen: false,
  editEntry: null,
  openCreateDialog: () => set({ entryDialogOpen: true, editEntry: null }),
  openEditDialog: (entry) => set({ entryDialogOpen: true, editEntry: entry }),
  closeEntryDialog: () => set({ entryDialogOpen: false, editEntry: null }),

  // Week navigation
  weekOffset: 0,
  setWeekOffset: (offset) =>
    set((state) => ({
      weekOffset: typeof offset === "function" ? offset(state.weekOffset) : offset,
    })),

  // Everyone view
  selectedMemberId: null,
  selectedMemberName: "",
  selectedMemberEmail: "",
  openMemberDialog: (id, name, email) =>
    set({ selectedMemberId: id, selectedMemberName: name, selectedMemberEmail: email }),
  closeMemberDialog: () =>
    set({ selectedMemberId: null, selectedMemberName: "", selectedMemberEmail: "" }),
}));
